export const isUserUSBased = async (): Promise<boolean> => {
  try {
    const CLOUDFLARE_TRACE_URL = "https://1.1.1.1/cdn-cgi/trace";
    const response = await fetch(CLOUDFLARE_TRACE_URL);
    if (response.ok) {
      const data = await response.text();
      const arr = data
        .trim()
        .split("\n")
        .map(e => e.split("="));
      const cfJSON: Record<string, string> = Object.fromEntries(arr);
      console.log(cfJSON);
      return cfJSON?.loc === "US";
    }
  } catch (e) {
    console.error(`Could not determine user location`, e);
    return Promise.resolve(false);
  }
  return Promise.resolve(false);
};
